(function () {
    function formatUploadField() {
        let translation = php_vars;
        let btn = document.querySelector('.codedropz-btn-wrap .cd-upload-btn');

        if( btn ) {
            btn.innerHTML = translation.attach_file + '<button class="button button--black">' + translation.choose_file + '</button>' ;
        }
    }
    function selectAllFeature() {
        let checkboxWrapper = document.querySelector('#select-all');

        if (checkboxWrapper ) {
            let checkbox = checkboxWrapper.querySelector('input');
            let agreements = document.querySelectorAll('.contactForm input[type="checkbox"]');

            checkboxWrapper.addEventListener('click', function() {
                if ( agreements ) {
                    if(checkbox.checked) {
                        agreements.forEach(function(item) {
                            item.checked = true;
                        });
                    } else {
                        agreements.forEach(function(item) {
                            item.checked = false;
                        });
                    }
                }
            });
        }
    }


    window.addEventListener('load', function () {
        formatUploadField();
        selectAllFeature();
    });
})()


//////////////////
// WEBPACK FOOTER
// ./js/modules/contact.js
// module id = 14
// module chunks = 0